import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-loader-main-color: var(--sds-loader-main-color, var(--sds-color-action-contrast-default, var(--sds-color-main-action-contrast-default)));
		--_sds-loader-secondary-color: var(--sds-loader-secondary-color, var(--sds-color-border-subtle, var(--sds-color-main-border-subtle)));
		--_sds-loader-animation-duration: var(--sds-loader-animation-duration, 2.5s);
		--_sds-loader-size: var(--sds-loader-size, var(--sds-components-icon-md));

		display: flex;
	}
	:host([contrast]):host([data-palette]),
	:host([contrast]) {
		--_sds-loader-main-color: var(--sds-loader-main-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-loader-secondary-color: var(--sds-loader-secondary-color, var(--sds-color-border-subtle, var(--sds-color-main-border-subtle)));
	}

	:host([data-palette]) {
		--_sds-loader-main-color: var(--sds-loader-main-color, var(--sds-color-action-contrast-default, var(--sds-color-main-action-contrast-default)));
		--_sds-loader-secondary-color: var(--sds-loader-secondary-color, var(--sds-color-border-subtle, var(--sds-color-main-border-subtle)));
	}

	:host([size='small']), /* Deprecated */
	:host([size='sm']) {
		--_sds-loader-size: var(--sds-loader-size, var(--sds-components-icon-sm));
	}

	:host([size='large']), /* Deprecated */
	:host([size='lg']) {
		--_sds-loader-size: var(--sds-loader-size, var(--sds-components-icon-lg));
	}

	.sds-loader {
		animation: sds-loader-rotate-animation linear infinite var(--_sds-loader-animation-duration);
		box-sizing: border-box;
		font-size: var(--_sds-loader-size);
		height: 1em;
		width: 1em;
		padding: 1px;
	}

	.sds-loader__background {
		stroke: var(--_sds-loader-main-color);
	}

	.sds-loader__circle {
		animation: sds-loader-stroke-animation ease-in-out infinite var(--_sds-loader-animation-duration);
		stroke-dasharray: 1px, 200px;
		stroke: var(--_sds-loader-secondary-color);
		transform-origin: center;
	}

	@keyframes sds-loader-rotate-animation {
		0% {
			transform: rotate(0);
		}

		to {
			transform: rotate(1turn);
		}
	}

	@keyframes sds-loader-stroke-animation {
		0% {
			stroke-dasharray: 1px, 200px;
			stroke-dashoffset: 0;
		}

		50% {
			stroke-dasharray: 100px, 200px;
			stroke-dashoffset: -15px;
		}

		to {
			stroke-dasharray: 1px, 200px;
			stroke-dashoffset: -120px;
		}
	}
`;
